import React, { useContext } from 'react'
import AccountContext from "../../context/accounts/accountContext";
export const Footer = () => {
    const accountContext = useContext(AccountContext);
    const { user } = accountContext;
    const isLoggedOn = Object.entries(user).length > 0 ? true : false;
    console.log(process.env);
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL
    console.log("Footer isLoggedOn: ", isLoggedOn, " adminEmail: ", adminEmail);
  
    return (
        <>
            {isLoggedOn &&
                <footer id="footer">

                    <div className="uk-card uk-card-default uk-card-body uk-background-cb-2 uk-margin-top"

                    >  <div className="uk-flex@s uk-flex-between">
                            <div>
                                <span>For any queries or issues, kindly navigate to the '<b>CONTACT US</b>' section or alternatively, you may send an email to <b>{adminEmail}</b>.</span>
                            </div>
                        </div>

                    </div>
                </footer>
            }
        </>
    )
}
